import { Component } from '@theme/component';


class QuotationFormComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.sectionId = this.dataset.sectionId || '';
    this._state = {};
    this._mount();

    const form = this.closest('form');
    if (form) {
      form.setAttribute('novalidate', '');
      form.addEventListener('submit', (e) => this._handleFormSubmit(e));
    }

    if (Shopify?.designMode) {
      document.addEventListener('shopify:section:load', (e) => {
        if (e.detail?.sectionId === this.sectionId) this._reinit();
      });
      document.addEventListener('shopify:section:select', (e) => {
        if (e.detail?.sectionId === this.sectionId) this._reinit();
      });
    }
  }

  _mount() {
    if (document.querySelector('[data-qf-posted-successfully]')) {
      const panel = document.querySelector('[data-qf-panel]');
      const hero = document.querySelector('[data-qf-hero]');
      const trigger = document.querySelector('[data-qf-trigger]');
      if (panel) panel.removeAttribute('hidden');
      if (hero) hero.classList.add('is-collapsed');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      this._setHeaderSolid();
      this._bindNav();
      this._goToStep('confirmation');
      return;
    }
    this._bindNav();
    this._bindProfileCards();
    this._bindProductCards();
    this._bindQtyCards();
    this._bindFreqCards();
    this._bindEditLinks();
    this._bindContactFields();
    this._bindCustomSelects();
    this._bindBillingToggle();
    this._goToStep(1);
  }

  _reinit() {
    this._state = {};
    this._goToStep(1);
  }

  _bindNav() {
    this.querySelector('[data-qf-next]')?.addEventListener('click', () => this._handleNext());
    this.querySelector('[data-qf-prev]')?.addEventListener('click', () => this._handlePrev());
    this.querySelectorAll('[data-qf-prev-mobile]').forEach((btn) => {
      btn.addEventListener('click', () => this._handlePrev());
    });
    this.querySelectorAll('[data-qf-next-mobile]').forEach((btn) => {
      btn.addEventListener('click', () => this._handleNext());
    });

    const trigger = document.querySelector('[data-qf-trigger]');
    const panel = document.querySelector('[data-qf-panel]');
    const hero = document.querySelector('[data-qf-hero]');
    if (trigger && panel) {
      trigger.addEventListener('click', () => {
        panel.removeAttribute('hidden');
        trigger.setAttribute('aria-expanded', 'true');
        if (hero) hero.classList.add('is-collapsed');
        this._setHeaderSolid();
        this._setHeaderStickyActive();
      });
    }

    this.querySelector('[data-qf-new-request]')?.addEventListener('click', () => {
      this._resetForm();
    });
  }

  _setHeaderSolid() {
    const header = document.querySelector('header-component');
    if (!header) return;
    this._savedTransparent = header.getAttribute('transparent');
    this._savedColorScheme = header.getAttribute('data-transparent-color-scheme');
    header.removeAttribute('transparent');
    header.removeAttribute('data-transparent-color-scheme');
    // Inject override style so the top-row background is cream, not white
    if (!document.getElementById('qf-header-solid-style')) {
      const style = document.createElement('style');
      style.id = 'qf-header-solid-style';
      style.textContent = 'header-component:not([transparent]) .header__row--top { background-color: var(--color-cream, #F4F0E4) !important; }';
      document.head.appendChild(style);
    }
  }

  _setHeaderStickyActive() {
  const header = document.querySelector('header-component#header-component');
    if (!header) return;
    header.setAttribute('data-sticky-state', 'active');
  }

  _restoreHeaderTransparent() {
    const header = document.querySelector('header-component');
    if (!header) return;
    if (this._savedTransparent) header.setAttribute('transparent', this._savedTransparent);
    if (this._savedColorScheme) header.setAttribute('data-transparent-color-scheme', this._savedColorScheme);
    const style = document.getElementById('qf-header-solid-style');
    if (style) style.remove();
  }

  _resetForm() {
    this._state = {};
    this.querySelectorAll('[data-qf-field] input, [data-qf-field] select, [data-qf-field] textarea').forEach((input) => {
      input.value = '';
    });
    this.querySelectorAll('[data-qf-consent]').forEach((cb) => { cb.checked = false; });
    this.querySelectorAll('[data-qf-select-value]').forEach((valueLabel) => {
      const select = valueLabel.closest('[data-qf-field]')?.querySelector('[data-qf-select]');
      const placeholderOption = select?.querySelector('option[value=""]');
      valueLabel.textContent = placeholderOption ? placeholderOption.textContent.trim() : '';
      valueLabel.classList.add('is-placeholder');
    });
    const billingToggle = this.querySelector('[data-qf-billing-toggle]');
    if (billingToggle) {
      billingToggle.checked = false;
      billingToggle.dispatchEvent(new Event('change'));
    }
    this.querySelectorAll('.is-selected').forEach((el) => el.classList.remove('is-selected'));
    const nextBtn = this.querySelector('[data-qf-next]');
    if (nextBtn) nextBtn.disabled = false;
    this._goToStep(1);
    const hero = document.querySelector('[data-qf-hero]');
    if (hero) hero.classList.remove('is-collapsed');
    this._restoreHeaderTransparent();
    const panel = document.querySelector('[data-qf-panel]');
    // if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  _bindProfileCards() {
    this.querySelectorAll('[data-profile-card]').forEach((card) => {
      card.addEventListener('click', () => this._selectProfile(card));
    });
  }

  _bindProductCards() {
    this.querySelectorAll('[data-product-id]').forEach((card) => {
      card.addEventListener('click', () => this._toggleProduct(card));
    });
  }

  _bindQtyCards() {
    this.querySelectorAll('[data-qty-card]').forEach((card) => {
      card.addEventListener('click', () => this._selectQty(card));
    });
  }

  _bindFreqCards() {
    this.querySelectorAll('[data-freq-card]').forEach((card) => {
      card.addEventListener('click', () => this._selectFreq(card));
    });
  }

  _bindEditLinks() {
    this.querySelectorAll('[data-qf-edit]').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        this._goToStep(parseInt(link.dataset.qfEdit));
      });
    });
  }

  _bindContactFields() {
    this.querySelectorAll('[data-qf-field] input, [data-qf-field] select, [data-qf-field] textarea').forEach((input) => {
      input.addEventListener('input', () => {
        const field = input.closest('[data-qf-field]');
        if (field) this._clearFieldError(field);
      });
    });
  }

  /**
   * "Fonction" (and any future `select`-type field block) renders a native
   * <select> paired with a custom chevron trigger + menu for the brand-styled
   * dropdown, mirroring the topic select in custom-contact-form.liquid.
   */
  _bindCustomSelects() {
    this.querySelectorAll('[data-qf-select]').forEach((select) => {
      const field = select.closest('[data-qf-field]');
      if (!field || field.dataset.qfSelectReady === 'true') return;

      const trigger = field.querySelector('.qf-custom-select__trigger');
      const valueLabel = field.querySelector('[data-qf-select-value]');
      const menu = field.querySelector('.qf-custom-select__menu');
      const options = Array.from(field.querySelectorAll('[data-qf-select-option]'));
      if (!trigger || !valueLabel || !menu || options.length === 0) return;

      field.dataset.qfSelectReady = 'true';

      const close = () => {
        menu.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      };
      const open = () => {
        menu.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
      };
      const syncSelected = (value) => {
        options.forEach((option) => {
          const isSelected = option.dataset.value === value;
          option.classList.toggle('is-selected', isSelected);
          option.setAttribute('aria-selected', String(isSelected));
        });
      };
      const setValue = (value, label, shouldFocus = true) => {
        select.value = value;
        valueLabel.textContent = label;
        valueLabel.classList.toggle('is-placeholder', !value);
        syncSelected(value);
        select.dispatchEvent(new Event('change', { bubbles: true }));
        close();
        if (shouldFocus) trigger.focus();
        this._clearFieldError(field);
      };

      const selectedOption = select.options[select.selectedIndex];
      if (select.value && selectedOption) {
        valueLabel.textContent = selectedOption.textContent.trim();
        valueLabel.classList.remove('is-placeholder');
        syncSelected(select.value);
      }

      trigger.addEventListener('click', () => {
        if (menu.hidden) {
          open();
          (options.find((o) => o.classList.contains('is-selected')) || options[0]).focus();
        } else {
          close();
        }
      });

      trigger.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          open();
          (options.find((o) => o.classList.contains('is-selected')) || options[0]).focus();
        }
      });

      options.forEach((option, index) => {
        option.addEventListener('click', () => setValue(option.dataset.value, option.textContent.trim()));
        option.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setValue(option.dataset.value, option.textContent.trim());
          } else if (event.key === 'ArrowDown') {
            event.preventDefault();
            (options[index + 1] || options[0]).focus();
          } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            (options[index - 1] || options[options.length - 1]).focus();
          } else if (event.key === 'Escape') {
            close();
            trigger.focus();
          }
        });
      });

      document.addEventListener('click', (event) => {
        if (!field.contains(event.target)) close();
      });
    });
  }

  /**
   * "Cette adresse, est mon adresse de facturation" — checked means billing
   * is the same as shipping, so the separate billing-address group is hidden
   * (and excluded from validation/collection, see the `[hidden]` guards in
   * _validateContact/_collectContact below).
   */
  _bindBillingToggle() {
    const toggle = this.querySelector('[data-qf-billing-toggle]');
    const group = this.querySelector('[data-qf-billing-group]');
    if (!toggle || !group) return;
    const sync = () => { group.hidden = toggle.checked; };
    toggle.addEventListener('change', sync);
    sync();
  }

  _goToStep(step) {
    this.querySelectorAll('[data-qf-step]').forEach((panel) => {
      panel.hidden = true;
    });

    const panel = this.querySelector(`[data-qf-step="${step}"]`);
    if (panel) panel.hidden = false;

    this._state.step = step;

    this._updateNav(step);

    if (panel?.dataset.qfStepType === 'step_quantity') this._renderStep2();

    // this.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  _totalSteps() {
    return this.querySelectorAll('[data-qf-step]:not([data-qf-step="confirmation"])').length;
  }

  _updateNav(step) {
    const isConfirmation = step === 'confirmation';
    const nav = this.querySelector('[data-qf-nav]');
    if (nav) nav.hidden = isConfirmation;
    if (isConfirmation) return;

    const numStep = typeof step === 'number' ? step : 0;

    // Desktop step indicators
    this.querySelectorAll('[data-qf-indicator]').forEach((ind) => {
      const n = parseInt(ind.dataset.qfIndicator);
      ind.classList.toggle('is-active', n === numStep);
      ind.classList.toggle('is-done', n < numStep);
      ind.classList.toggle('is-future', n > numStep);
    });

    // Desktop prev button — always visible; on step 1 goes back to hero
    const prevBtn = this.querySelector('[data-qf-prev]');
    if (prevBtn) prevBtn.hidden = false;

    // Desktop next button
    const nextBtn = /** @type {HTMLButtonElement|null} */ (this.querySelector('[data-qf-next]'));
    if (nextBtn) {
      nextBtn.hidden = false;
      nextBtn.type = 'button';
      nextBtn.removeAttribute('form');
    }

    // Mobile prev buttons — always visible; on step 1 goes back to hero
    this.querySelectorAll('[data-qf-prev-mobile]').forEach((btn) => {
      btn.hidden = false;
    });

    // Mobile step indicators
    this.querySelectorAll('[data-qf-indicator-mobile]').forEach((ind) => {
      const n = parseInt(ind.dataset.qfIndicatorMobile);
      ind.classList.toggle('is-active', n === numStep);
      ind.classList.toggle('is-done', n < numStep);
      ind.classList.toggle('is-future', n > numStep);
    });

    // Mobile timeline scroll offset — shift track so active step is visible
    const offset = Math.max(0, numStep - 2) * 171;
    this.querySelectorAll('.qf-timeline-mobile__track').forEach((track) => {
      track.style.transform = `translateX(-${offset}px)`;
    });
  }

  _handleNext() {
    this._scrollToTopOnMobile();
    const step = this._state.step || 1;
    const total = this._totalSteps();
    if (step < total && this._validate(step)) {
      this._goToStep(step + 1);
    } else if (step === total) {
      this._submitQuotation();
    }
  }

  _handlePrev() {
    this._scrollToTopOnMobile();
    const step = this._state.step || 1;
    if (step <= 1) {
      this._backToHero();
    } else {
      this._goToStep(step - 1);
    }
  }

  /**
   * Next/Prev navigation on mobile should snap the viewport back to the top
   * of the form panel, since step content can be taller than the screen and
   * the user may have scrolled down within the current step. Desktop keeps
   * its existing (non-scrolling) behavior.
   */
  _scrollToTopOnMobile() {
    if (window.matchMedia && !window.matchMedia('(max-width: 767px)').matches) return;
    const panel = document.querySelector('[data-qf-panel]') || this;
    const headerOffset = 64; // fixed mobile nav header height
    const top = panel.getBoundingClientRect().top + window.scrollY - headerOffset;
    window.scrollTo({ top, behavior: 'smooth' });
  }

  _backToHero() {
    const panel = document.querySelector('[data-qf-panel]');
    const hero = document.querySelector('[data-qf-hero]');
    if (panel) panel.setAttribute('hidden', '');
    if (hero) hero.classList.remove('is-collapsed');
    this._restoreHeaderTransparent();
    const trigger = document.querySelector('[data-qf-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    
    const header = document.querySelector('header-component#header-component');
    if (header) header.setAttribute('data-sticky-state', 'inactive');
  }

  _validate(step) {
    const panel = this.querySelector(`[data-qf-step="${step}"]`);
    const stepType = panel?.dataset.qfStepType;
    const errorEl = panel?.querySelector('[data-qf-error]');

    if (stepType === 'step_profile') {
      if (!this._state.profile) {
        this._showError(step, this.dataset.errNoProfile);
        return false;
      }
    }

    if (stepType === 'step_products') {
      if (!this._state.products?.length) {
        this._showError(step, this.dataset.errNoProduct);
        return false;
      }
    }

    if (stepType === 'step_quantity') {
      if (!this._state.quantity) {
        this._showError(step, this.dataset.errNoQty);
        return false;
      }
    }

    if (stepType === 'step_frequency') {
      if (!this._state.delivery_frequency) {
        this._showError(step, this.dataset.errNoFreq);
        return false;
      }
    }

    if (stepType === 'step_contact') {
      if (!this._validateContact()) return false;
      this._collectContact();
    }

    if (errorEl) errorEl.hidden = true;
    return true;
  }

  _validateContact() {
    let valid = true;
    this.querySelectorAll('[data-qf-field]').forEach((field) => {
      if (field.closest('[hidden]')) return; // e.g. billing address when "same as shipping" is checked
      const isRequired = field.dataset.required === 'true';
      const isEmail = field.dataset.fieldKey === 'email';
      const input = field.querySelector('input, select, textarea');
      if (!input) return;

      const val = input.value.trim();
      const errorEl = field.querySelector('[data-qf-field-error]');

      if (isRequired && !val) {
        if (errorEl) { errorEl.textContent = this.dataset.errRequired ?? ''; errorEl.removeAttribute('hidden'); }
        valid = false;
      } else if (isEmail && val && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
        if (errorEl) { errorEl.textContent = this.dataset.errEmail ?? ''; errorEl.removeAttribute('hidden'); }
        valid = false;
      } else if (field.dataset.pattern && val && !new RegExp(field.dataset.pattern).test(val)) {
        const msg = field.dataset.errorMessage || this.dataset.errFormat || '';
        if (errorEl) { errorEl.textContent = msg; errorEl.removeAttribute('hidden'); }
        valid = false;
      }
    });

    const consent = this.querySelector('[data-qf-consent]');
    const consentError = this.querySelector('[data-qf-consent-error]');
    if (consent && !consent.checked) {
      if (consentError) { consentError.hidden = false; }
      valid = false;
    }

    return valid;
  }

  _clearFieldError(field) {
    const errorEl = field.querySelector('[data-qf-field-error]');
    if (errorEl) errorEl.hidden = true;
  }

  _collectContact() {
    const contact = {};
    this.querySelectorAll('[data-qf-field]').forEach((field) => {
      if (field.closest('[hidden]')) return; // e.g. billing address when "same as shipping" is checked
      const key = field.dataset.fieldKey;
      const input = field.querySelector('input, select, textarea');
      if (key && input) contact[key] = input.value;
    });
    this._state.contact = contact;
    this._state.consent = this.querySelector('[data-qf-consent]')?.checked || false;

  }

  _selectProfile(card) {
    this.querySelectorAll('[data-profile-card]').forEach((c) => c.classList.remove('is-selected'));
    card.classList.add('is-selected');
    this._state.profile = {
      id: card.dataset.profileId,
      label: card.dataset.profileLabel,
    };
    this._clearErrorForCard(card);

  }

  _toggleProduct(card) {
    const id = card.dataset.productId;
    const data = {
      product_id: id,
      handle: card.dataset.productHandle,
      title: card.dataset.productTitle,
      value: card.dataset.productValue || '',
      origin: card.dataset.productOrigin || '',
      image: card.dataset.productImage || '',
    };

    if (!this._state.products) this._state.products = [];
    const idx = this._state.products.findIndex((p) => p.product_id === id);

    if (idx >= 0) {
      this._state.products.splice(idx, 1);
      card.classList.remove('is-selected');
    } else {
      this._state.products.push(data);
      card.classList.add('is-selected');
    }

    this._clearErrorForCard(card);

  }

  _selectQty(card) {
    this.querySelectorAll('[data-qty-card]').forEach((c) => c.classList.remove('is-selected'));
    card.classList.add('is-selected');

    this._state.quantity = {
      option_id: card.dataset.optionId || '',
      label: card.dataset.label || '',
      format: card.dataset.format || '',
    };
    this._clearErrorForCard(card);

  }

  _selectFreq(card) {
    this.querySelectorAll('[data-freq-card]').forEach((c) => c.classList.remove('is-selected'));
    card.classList.add('is-selected');
    this._state.delivery_frequency = {
      id: card.dataset.freqId,
      label: card.dataset.freqLabel,
    };
    this._clearErrorForCard(card);

  }

  _renderStep2() {
    const qty = this._state.quantity;
    if (qty) {
      this.querySelector(`[data-qty-card][data-option-id="${qty.option_id}"]`)?.classList.add('is-selected');
    }
  }

  _renderReview() {
    const s = this._state;

    const productsEl = this.querySelector('[data-review-products]');
    if (productsEl) {
      productsEl.innerHTML = (s.products || []).map((p) =>
        `<div class="qf-review-row"><span class="qf-review-row__name">${p.title}</span></div>`
      ).join('');
    }

    const qtyEl = this.querySelector('[data-review-qty]');
    if (qtyEl) {
      const qty = s.quantity;
      qtyEl.textContent = qty ? `${qty.label}${qty.format ? ' (' + qty.format + ')' : ''}` : '—';
    }

    const freqEl = this.querySelector('[data-review-freq]');
    if (freqEl) freqEl.textContent = s.delivery_frequency?.label || '—';

    const contactEl = this.querySelector('[data-review-contact]');
    if (contactEl) {
      const c = s.contact || {};
      const lines = [
        [c.first_name, c.last_name].filter(Boolean).join(' '),
        c.email,
        c.phone,
        c.company,
        c.vat ? `TVA: ${c.vat}` : '',
        [c.street, c.street_number, c.street_box ? `bte ${c.street_box}` : ''].filter(Boolean).join(' '),
        [c.postal_code, c.city].filter(Boolean).join(' '),
      ].filter(Boolean);
      contactEl.innerHTML = lines.map((l) => `<div>${l}</div>`).join('');
    }
  }

  _restoreAllSelections() {
    const profile = this._state.profile;
    if (profile) {
      this.querySelector(`[data-profile-card][data-profile-id="${profile.id}"]`)?.classList.add('is-selected');
    }

    (this._state.products || []).forEach((p) => {
      this.querySelector(`[data-product-id="${p.product_id}"]`)?.classList.add('is-selected');
    });

    const freq = this._state.delivery_frequency;
    if (freq) {
      this.querySelector(`[data-freq-card][data-freq-id="${freq.id}"]`)?.classList.add('is-selected');
    }

    const contact = this._state.contact || {};
    Object.entries(contact).forEach(([key, val]) => {
      const input = this.querySelector(`[data-field-key="${key}"] input, [data-field-key="${key}"] select, [data-field-key="${key}"] textarea`);
      if (input) input.value = val;
    });
  }

  /** @param {SubmitEvent} e */
  _handleFormSubmit(e) {
    if (!this._allowSubmit) {
      e.preventDefault();
    }
    this._allowSubmit = false;
  }

  async _submitQuotation() {
    if (!this._validate(this._state.step)) return;
    this._collectContact();
    const payload = this._buildPayload();

    const nextBtns = this.querySelectorAll('[data-qf-next], [data-qf-next-mobile]');
    nextBtns.forEach((b) => { /** @type {HTMLButtonElement} */ (b).disabled = true; });
    this._hideSubmitError();

    const ok = await this._sendToApp(payload);

    if (!ok) {
      // Keep the user's data and let them retry.
      nextBtns.forEach((b) => { /** @type {HTMLButtonElement} */ (b).disabled = false; });
      this._showSubmitError(this.dataset.errSubmit);
      return;
    }

    this._state = {};
    this._goToStep('confirmation');
  }

  /**
   * Submit the quotation to the backend app via a Shopify App Proxy
   * (same-origin, e.g. /apps/quotation). The app validates the signed request,
   * creates the Odoo crm.lead, and sends notifications server-side — so no
   * Odoo token is exposed and there is no native contact form / reCAPTCHA.
   * @param {ReturnType<QuotationFormComponent['_buildPayload']>} payload
   * @returns {Promise<boolean>} true only on a 2xx response
   */
  async _sendToApp(payload) {
    const url = this.dataset.submitUrl;
    if (!url) return false;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    try {
      console.log("payload:", payload);
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        signal: controller.signal,
      });
      return res.ok;
    } catch (_) {
      return false;
    } finally {
      clearTimeout(timeout);
    }
  }

  /** @param {string} [msg] */
  _showSubmitError(msg) {
    const el = /** @type {HTMLElement|null} */ (this.querySelector('[data-qf-submit-error]'));
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = false;
  }

  _hideSubmitError() {
    const el = /** @type {HTMLElement|null} */ (this.querySelector('[data-qf-submit-error]'));
    if (el) el.hidden = true;
  }

  _buildPayload() {
    const s = this._state;
    return {
      locale: document.documentElement.lang?.split('-')[0] || 'fr',
      submitted_at: new Date().toISOString(),
      profile: s.profile || null,
      products: s.products || [],
      quantity: s.quantity || null,
      delivery_frequency: s.delivery_frequency || null,
      contact: s.contact || {},
      consent: s.consent || false,
    };
  }

  _showError(step, msg) {
    const errorEl = this.querySelector(`[data-qf-step="${step}"] [data-qf-error]`);
    if (!errorEl) return;
    errorEl.textContent = msg;
    const wrap = errorEl.closest('[data-qf-error-wrap]');
    if (wrap) { wrap.hidden = false; } else { errorEl.hidden = false; }
  }

  _clearError(step) {
    const errorEl = this.querySelector(`[data-qf-step="${step}"] [data-qf-error]`);
    if (!errorEl) return;
    const wrap = errorEl.closest('[data-qf-error-wrap]');
    if (wrap) { wrap.hidden = true; } else { errorEl.hidden = true; }
  }

  /** Clear the step error for whichever panel a clicked selection card lives in. */
  _clearErrorForCard(card) {
    const panel = card.closest('[data-qf-step]');
    if (panel) this._clearError(panel.dataset.qfStep);
  }

}

customElements.define('quotation-form-component', QuotationFormComponent);